import ResourceManager from "../../components/ResourceManager/ResourceManager"
import { CalendarEventViewModel } from "../api/calendar-event"
import { useCalendarEventMutations } from "../hooks/use-calendar-event-mutations"
import { useI18n } from "../../hooks/use-i18n"
import { useOptions } from "../../options/hooks/use-options"
import { StringMap } from "../../types/common"

const EventCustomersWidget = ({ calendarEvent }: { calendarEvent: CalendarEventViewModel }) => {
  const translations = useTranslations(defaultTranslations)
  const { customerOptions } = useOptions(calendarEvent.organisation?.id || "")
  const { updateCustomers } = useCalendarEventMutations()

  const onAddCustomers = (ids: string[]) => {
    const customers = [
      ...calendarEvent.customers,
      ...customerOptions.filter((c) => ids.includes(c.id)).map((c) => ({ id: c.id, name: c.name })),
    ]
    updateCustomers(calendarEvent.id, customers)
  }

  const onRemoveCustomer = (customerId: string) => {
    const customers = calendarEvent.customers.filter((c) => c.id !== customerId)
    updateCustomers(calendarEvent.id, customers)
  }

  const sortedCustomerOptions = customerOptions
    .slice()
    .sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))

  const sortedCustomers = calendarEvent.customers
    .slice()
    .sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))

  return (
    <ResourceManager
      title={translations.title}
      resourceOptions={sortedCustomerOptions}
      resources={sortedCustomers}
      canAddResource={calendarEvent.canUpdate}
      canRemoveResource={calendarEvent.canUpdate}
      onAddResources={onAddCustomers}
      onRemoveResource={onRemoveCustomer}
      emptyOptionsMessage={translations.emptyOptionsMessage}
      emptyResourcesMessage={translations.emptyResourcesMessage}
      isMultipleSelection
    />
  )
}

const useTranslations = (defaults = defaultTranslations) => {
  const { translations: t } = useI18n("calendarEvent")
  const translations = (t?.customerWidget || {}) as StringMap

  const {
    title = defaults.title,
    emptyOptionsMessage = defaults.emptyOptionsMessage,
    emptyResourcesMessage = defaults.emptyResourcesMessage,
    updateErrorMessage = defaults.updateErrorMessage,
  } = translations

  return {
    title,
    emptyOptionsMessage,
    emptyResourcesMessage,
    updateErrorMessage,
  }
}

const defaultTranslations = {
  title: "Customers",
  emptyOptionsMessage: "No customers in this organisation",
  emptyResourcesMessage: "This event is not connected to any customer",
  updateErrorMessage: "Failed to update customers",
}

export default EventCustomersWidget
